export availabilities from './availabilities/handlers';
export cancellationPolicy from './cancellation-policy/handlers';
export customer from './customer/handlers';
export inquiry from './inquiry/handlers';
export payment from './payment/handlers';
export rentalRuleset from './rental-ruleset/handlers';
export checkInOutRuleset from './check-in-out-ruleset/handlers';
export reservation from './reservation/handlers';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/handlers.js